import { render } from "./QuotesCompletedPurchasesPage.vue?vue&type=template&id=2cadc044"
import script from "./QuotesCompletedPurchasesPage.vue?vue&type=script&lang=js"
export * from "./QuotesCompletedPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__